import React from 'react'
import { useOutletContext } from 'react-router-dom'
import PricingView from '../pricing/PricingView'
import { usePageTitle } from '../../components/common/PageTitleContext'
import type { AppOutletContext } from '../../app/AppShell'

const BillingPage: React.FC = () => {
  const { me } = useOutletContext<AppOutletContext>()

  usePageTitle('Billing')

  return <PricingView variant="app" me={me} isLoggedIn={true} />
}

export default BillingPage
